import {Box} from '@chakra-ui/react';
import {FC} from 'react';
import {
  DefaultUnitLabels,
  SchemaType,
  UnitLabels,
} from '../../CountdownDefinition';
import {CountdownUnit} from '../Unit';
import {CountdownUnitPropsBase} from '../Unit/Unit';

interface ClockProps
  extends Pick<
    SchemaType,
    | 'divider'
    | 'isCountdownColumn'
    | 'isUnitUnderNum'
    | 'typography'
    | 'unitLabels'
  > {
  dateParts: DateParts;
  hasDaysLeft: boolean;
}

type DateParts = {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
};

export const Clock: FC<ClockProps> = (props) => {
  const {
    isCountdownColumn = false,
    hasDaysLeft,
    dateParts,
    divider,
    isUnitUnderNum = true,
    typography = {},
    unitLabels = {},
  } = props;
  const {days, hours, minutes, seconds} = dateParts;
  const baseUnitProps: CountdownUnitPropsBase = {
    divider,
    isUnitUnderNum,
    typography,
  };
  const getUnitLabel = (typedUnit: keyof UnitLabels): string => {
    return unitLabels[typedUnit] ?? DefaultUnitLabels[typedUnit];
  };
  return (
    <Box
      className="countdown-clock"
      display="flex"
      flexDirection={isCountdownColumn ? 'column' : 'row'}
      alignItems={isCountdownColumn ? 'center' : 'flex-start'}
      justifyContent={isCountdownColumn ? 'center' : 'flex-start'}
      fontWeight="100"
    >
      {hasDaysLeft ? (
        <CountdownUnit
          {...baseUnitProps}
          timeValue={days}
          typedUnit="days"
          unitLabel={getUnitLabel('days')}
          withDivider
        />
      ) : null}
      <CountdownUnit
        {...baseUnitProps}
        timeValue={hours}
        typedUnit="hours"
        unitLabel={getUnitLabel('hours')}
        withDivider
      />
      <CountdownUnit
        {...baseUnitProps}
        timeValue={minutes}
        typedUnit="minutes"
        unitLabel={getUnitLabel('minutes')}
        withDivider={!hasDaysLeft}
      />
      {hasDaysLeft ? null : (
        <CountdownUnit
          {...baseUnitProps}
          timeValue={seconds}
          typedUnit="seconds"
          unitLabel={getUnitLabel('seconds')}
          withDivider={false}
        />
      )}
    </Box>
  );
};
